import PhoneUtils from 'application/utils/PhoneUtils';

import { Country } from 'domain/api/graphql/generated';

export const isBelarusCountry = (phone: string) => {
  const normalizedPhone = PhoneUtils.normalizePhoneNumber(phone);
  const parsedValue = PhoneUtils.parsePhoneNumberFromString(normalizedPhone);

  return parsedValue?.country === Country.By;
};

export const isKazahstanCountry = (phone: string) => {
  const normalizedPhone = PhoneUtils.normalizePhoneNumber(phone);
  const parsedValue = PhoneUtils.parsePhoneNumberFromString(normalizedPhone);

  return parsedValue?.country === Country.Kz;
};

export const isRussiaCountry = (phone: string) => {
  const normalizedPhone = PhoneUtils.normalizePhoneNumber(phone);
  const parsedValue = PhoneUtils.parsePhoneNumberFromString(normalizedPhone);

  return parsedValue?.country === Country.Ru;
};
